import { gsap } from "gsap";
import { useEffect } from "react";

export function useDataWIdAnimation33() {
  useEffect(() => {
    gsap.set('[data-w-id="cf9a4099-fb5b-8e4d-763c-29b714670351"]', {"y": "10%"});
    gsap.set('[data-w-id="cf9a4099-fb5b-8e4d-763c-29b714670351"]', {"opacity": 0});
                const tl = gsap.timeline({"scrollTrigger": {"trigger": "[data-w-id=\"cf9a4099-fb5b-8e4d-763c-29b714670351\"]", "start": "top 70%", "end": "bottom top", "toggleActions": "play none none none", "once": true}});
      tl.addLabel("label0");
      tl.to('[data-w-id="cf9a4099-fb5b-8e4d-763c-29b714670351"]', {"duration": 0.5, "delay": 0.7, "ease": "power1.inOut", "y": "0%"}, "label0");
      tl.to('[data-w-id="cf9a4099-fb5b-8e4d-763c-29b714670351"]', {"duration": 0.5, "delay": 0.7, "ease": "power1.inOut", "opacity": 1}, "label0");
    return () => {
      tl.kill();
    };
  }, []);
}